import { render, staticRenderFns } from "./ModalExportKomship.vue?vue&type=template&id=bad74e8e&"
import script from "./ModalExportKomship.vue?vue&type=script&lang=js&"
export * from "./ModalExportKomship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports